export class Sobre {

    id: number;
    descricao: string = '';
    imagem: string = '';
    [x: string]: any;

    constructor(obj?) {
        Object.assign(this);
    }
}